<div class="media-asset">
  <div class="media-asset-visualizer">
    <audio [src]="audioURL$ | async" controls [controlsList]="!(asset.expiryDate | dateNotExpired) ? 'nodownload' : ''" preload="metadata"></audio>
  </div>
</div>
